<template>
  <div>
    <AllegroAccountHeader
      :accountPk="route.params.pk"
      :accountData="accountData"
      activeTab="threads"
    >
      <div class="row order-filters">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5>Filtry</h5>
              <div class="ibox-tools"></div>
            </div>
            <div class="ibox-content">
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label>Odczytana</label>
                  <select
                    v-model="readFilter"
                    class="form-control inputClass"
                    @change="getThreads"
                  >
                    <option value="">Wszystkie</option>
                    <option value="true">Tak</option>
                    <option value="false">Nie</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Lista wiadomości</h5>
          <div class="ibox-tools"></div>
        </div>
        <div class="ibox-content">
          <EasyDataTable
            :headers="headers"
            :items="items"
            :body-row-class-name="bodyRowClassNameFunction"
            border-cell
            alternating
            buttons-pagination
            @click-row="openThread"
            class="table-search"
          >
            <template #header="header">
              <span v-if="header.text">{{ header.text }}</span>
              <input
                v-if="header.searchKey"
                v-model="searchValue[header.searchKey]"
                class="table-search"
                type="text"
                @keyup="searchThreads"
                @click.stop
              />
            </template>
            <template #item-client_email="item">
              <router-link
                v-if="item.client_pk"
                :to="`/clients/${item.client_pk}`"
                @click.stop
              >
                {{ item.client_email }}
              </router-link>
              <span v-else>{{ item.client_email }}</span>
            </template>
          </EasyDataTable>
        </div>
      </div>
    </AllegroAccountHeader>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import router from "../../router/router";
import AllegroAccountHeader from "./AllegroAccountHeader.vue";

export default {
  name: "AllegroAccountThreads",
  components: { AllegroAccountHeader },
  setup() {
    const route = useRoute();
    const store = useStore();
    const accountData = ref({});
    const items = ref([]);
    const readFilter = ref("");
    const searchValue = ref({});
    // searchKey maps a column onto the filter the backend exposes for it
    const headers = [
      {
        text: "Klient",
        value: "client_full_name",
        searchKey: "client_name",
        sortable: true,
      },
      {
        text: "E-mail",
        value: "client_email",
        searchKey: "client_email",
        sortable: true,
      },
      {
        text: "Data ostatniej wiadomości",
        value: "last_message_date_time",
        searchKey: "last_message_date_time",
        sortable: true,
      },
    ];

    // Unread threads highlighted the same way as in the old admin panel
    // (exposingData: read === false -> #f8ac59)
    const bodyRowClassNameFunction = (item) =>
      item.read === false ? "yellow-row" : "";
    const threadsRaw = computed(
      () => store.getters.getAllegroAccountThreadsData
    );
    const accountRaw = computed(() => store.getters.getAllegroAccountData);
    const openThread = (item) => {
      router.push({
        name: "AllegroThreadDetails",
        params: { pk: item.pk },
      });
    };

    const getThreads = () => {
      store.dispatch("getAllegroAccountThreads", {
        accountPk: route.params.pk,
        search: {
          read: readFilter.value,
          ...searchValue.value,
        },
      });
    };

    let searchTimeout = null;
    const searchThreads = () => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(getThreads, 400);
    };

    store.dispatch("getAllegroAccount", route.params.pk);
    getThreads();
    watch(
      () => threadsRaw.value,
      (newValue) => {
        const data = newValue?.data;
        const results = data?.results ? data.results : data || [];
        // Client data comes nested (client.user), the table needs it flat
        items.value = results.map((thread) => ({
          ...thread,
          client_full_name: thread.client?.user?.full_name || "-",
          client_email: thread.client?.user?.email || "-",
        }));
      },
      { deep: true }
    );
    watch(
      () => accountRaw.value,
      (newValue) => {
        accountData.value = newValue?.data || {};
      },
      { deep: true }
    );

    return {
      route,
      headers,
      items,
      openThread,
      bodyRowClassNameFunction,
      accountData,
      readFilter,
      getThreads,
      searchValue,
      searchThreads,
    };
  },
};
</script>
